import React, {Fragment} from "react";
import {Button} from "@mui/material";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";

import AuthStats from "../components/AuthStats";
import useLogout from "../hooks/useLogout";


export default function Home() {

  const navigate = useNavigate();

  const signOut = async () => {
    await logout();
    navigate('/login');
  }


  const logout = useLogout();

  return (

      <Container>

        <Row className="mb-5" style={{minHeight: '300px'}}>
          <Col xs={12} sm={6}>
            <div className="border rounded">
                <div className="w-50 h-50 my-5 mx-auto text-center">

                    <Fragment>
                      <Button fullWidth style={{marginBottom: "10px"}} variant="contained" type="big" component={RouterLink} to={'/products'}>NEW ORDER</Button><br/>
                      {/* <Button fullWidth style={{marginBottom: "10px"}} variant="contained" type="big" component={RouterLink} to={'/orders'}>REORDER</Button><br/> */}
                      <Button fullWidth style={{marginBottom: "10px"}} variant="contained" type="big" component={RouterLink} to={'/address-book'}>ADDRESS BOOK</Button><br/>
                      <Button fullWidth style={{marginBottom: "10px"}} variant="contained" type="big" component={RouterLink} to={'/account'}>MY ACCOUNT</Button><br/>
                      <Button fullWidth style={{marginBottom: "10px"}} variant="contained" type="big" component={RouterLink} onClick={signOut}>LOGOUT</Button><br/>
                    </Fragment>

                </div>
            </div>
          </Col>

          <Col xs={12} sm={6}>

            <div className="pb-4">
              <h2>iStore News</h2>
              <p>Got Solar? Add an iStore as a Thermal Battery</p>

              <p style={{color:'#555'}}>
                Historically, generating excess energy from your rooftop solar system was financially beneficial as
                you could sell this excess energy back to the grid at a high rate.
              </p>

              <p style={{color:'#555'}}>
                As an example, for systems installed before July 2011 in Western Australia, the excess
                electricity could be sold back to the grid
                for up to 47 cents per kWh exported. This meant you would have little to nothing to pay on your bills.
                Nowadays, the going rate for feed-in tariffs are as low as 2.5 cents, yet you are paying around 30
                cents per kWh to buy that energy back in the evenings when your panels aren’t producing.
              </p>
            </div>

          </Col>

        </Row>

        <AuthStats />

      </Container>

  );
}
